module.exports = __webpack_public_path__ + "img/ima_plus_white.755c186e.png";